export default "__VITE_ASSET__85453b8e__"